<motn-drawer-gap-from-top
  (clickedOutside$)="clickedOutside.emit($event)"
>
  <div
    class="outer"
  >
    <div
      class="content devices"
    >
      <h3>
        Device Discovery
        <motn-pill color="indigo">BACnet/IP</motn-pill>
      </h3>

      @if (!getCurrentSelectedHub()) {
        <div
          class="fake-select error"
          (click)="hubMenuOpen = true"
        >
          &nbsp;
        </div>
      }

      @if (getCurrentSelectedHub()) {
        <div
          class="fake-select"
          (click)="hubMenuOpen = true"
          [innerText]="$safeNavigationMigration(getCurrentSelectedHub()?.Name)"
        ></div>
      }

      @if (hubMenuOpen) {
        <motn-popover-select-hubs
          [hubs]="hubs"
          (clickedOutsideMenu$)="hubMenuOpen = false"
          (clickedOption$)="onHubChange($event); hubMenuOpen = false"
        ></motn-popover-select-hubs>
      }

      <div class="label">
        Motion Hub
        <motn-info-circle
          [message]="'Choose a Motion Hub connected to the same network as the BACnet/IP devices you want to find via device discovery.'"
        ></motn-info-circle>
      </div>

      <motn-multichoice-horizontal
        [options]="timeoutOptions"
        (selectedItem$)="updateTimeout($event)"
      ></motn-multichoice-horizontal>

      <div class="label">
        Timeout
        <span
          (click)="infoDialog(INFO_TIMEOUT)"
        >
          <i class="fa-regular fa-circle-info"></i>
        </span>
      </div>

      <div class="buttons">
        <button
          type="button"
          [ngClass]="{'loading': discovering}"
          (click)="startDiscovery()"
        >
          <span>Start Discovery</span>
          <motn-spinner></motn-spinner>
        </button>

        <button
          type="button"
          [ngClass]="{'red': discovering, 'alt': !discovering}"
          (click)="stopDiscovery()"
        >
          <span>Abort</span>
        </button>

        <label class="warning">
          <i class="far fa-exclamation-triangle"></i> Device discovery can temporarily interrupt BACnet traffic.
          <span
            (click)='infoDialog(INFO_INTERRUPTIONS)'
            style="text-decoration: underline"
          >More info</span>
        </label>
      </div>
    </div>
  </div>

  <div
    class="outer"
  >
    @if (bacnetDevices.length > 0) {
      <div
        class="content results"
      >
        <h3>
          <div class="text">
            Devices Found

            <motn-pill>{{filteredBacnetDevices.length}}</motn-pill>
          </div>

          <div class="search">
            <input
              class="small"
              placeholder="Search within results..."
              [(ngModel)]="searchTerm"
              (ngModelChange)="filterAndRenderDevices()"
            >
          </div>
        </h3>

        <motn-sort-table
          [table$]="table$"
        ></motn-sort-table>
      </div>
    }
  </div>
</motn-drawer-gap-from-top>
